import * as React from 'react'
import Box from '@mui/material/Box'

import { TextField, Typography } from '@mui/material'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../../redux/actions/app'
import { useDispatch } from 'react-redux'
import { getEmailUserLogged } from '../../../../utils/UserTools'
import { helpGetUserLoginAccountWithEmail } from '../../../../app/services/LoginAccount/helpGetUserLoginAccountWhitEmail'
import { createUserCognito } from '../../../../app/services/eAuth/createUserBasseAccountEAuth'
import { logEvent } from '../../../../utils/LogEvents'
import { v4 as uuidv4 } from 'uuid'
import { getUserOrganizationByLoginAccountCorpEntities } from '../../../../app/services/Organization/getUserOrganizationByLoginAccountCorpEntities'
import { addUserOrganizationCorpEntities } from '../../../../app/services/Organization/helpAddUserOfOrganization'
import { assignUserSubscriberCorpEntity } from '../../../../app/services/Suscriber/assignUserSubscriberCorpEntity'
import { createSubscriberRegistrationUserInvite } from '../../../../app/services/Invite/createSuscriberregistratonInvite'
import { createUser } from '../../../../app/services/LoginAccount/CreateUser'
import {
  createSuscriberRequest,
  getSuscriberRefID
} from '../../../../redux/actions/Suscriber'

export default function StepperAddSuscriber ({
  item,
  setLoading,
  setstateAddSuscriber
}) {
  const dispatch = useDispatch()

  // hooks new suscriber values
  const [number, setnumber] = React.useState('')
  const [email, setemail] = React.useState('')
  const [businessName, setbusinessName] = React.useState('')
  const [maxUsers, setmaxUsers] = React.useState(1)

  // hooks contain error text
  const [errorNumber, changeErrorNumber] = React.useState(false)
  const [errorEmail, changeErrorEmail] = React.useState(false)
  const [errorbusinessName, changeErrorbusinessName] = React.useState(false)
  const [errorMaxUsers, changeErrorMaxUsers] = React.useState(false)

  // text error warning
  const [errorText, setErrorText] = React.useState('')

  const handleChangeEmail = (event) => {
    setemail(event.target.value)
    clearErrors()
  }

  const handleChangeNumber = (event) => {
    setnumber(event.target.value)
    clearErrors()
    // validate number type
    const number = isNaN(event.target.value)
    if (number || event.target.value < 0) {
      setErrorText('Ingrese un número valido')
      changeErrorNumber(true)
    }
  }

  const handleChangebusinessName = (event) => {
    setbusinessName(event.target.value)
    clearErrors()
  }
  const handleChangeMaxUsers = (event) => {
    setmaxUsers(event.target.value)
    // validate number type
    const number = parseInt(event.target.value)
    if (number > 0) {
      clearErrors()
    } else {
      setErrorText('Ingrese un número valido')
      changeErrorMaxUsers(true)
    }
  }
  // set hooks error false
  const clearErrors = () => {
    changeErrorNumber(false)
    changeErrorEmail(false)
    changeErrorbusinessName(false)
    changeErrorMaxUsers(false)
  }

  // validate email input
  const validateEmail = (email) => {
    const regex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i
    return regex.test(email)
  }

  // verify if inputs completed
  const isAttributesCompleted = () => {
    setErrorText('Este campo es requerido')
    if (!validateEmail(email) || email === '') {
      if (!validateEmail(email) && email !== '') {
        setErrorText('El email ingresado no es valido')
      }
      changeErrorEmail(true)
      changeErrorNumber(false)
      changeErrorbusinessName(false)
      return false
    }
    if (number === '') {
      changeErrorNumber(true)
      changeErrorEmail(false)
      changeErrorbusinessName(false)
      return false
    }

    if (businessName === '') {
      changeErrorNumber(false)
      changeErrorEmail(false)
      changeErrorbusinessName(true)
      return false
    }
    if (errorNumber) {
      return false
    }
    if (errorMaxUsers) {
      return false
    }
    return true
  }

  // open alert error
  const handleSetError = (text) => {
    dispatch(setRequestTextSnackBar())
    dispatch(setErrorTextSnackBar(text))
    // error
    setLoading(false)
  }

  // validate is exists suscriber with number ref_id
  const isExistSuscriber = async (number) => {
    const params = {
      clicod: number
    }
    const suscriber = await dispatch(getSuscriberRefID(params))
    if (
      suscriber.response?.data?.message
        ?.toLowerCase()
        .includes('datos no encontrados')
    ) {
      return false
    }
    if (suscriber.message?.includes('failed')) {
      return 'error'
    }
    return true
  }

  // create suscriber process
  const createSuscriberProcess = async (newuser, myuuid) => {
    const suscriber = {
      clicod: number,
      subscriber_name: businessName,
      organization_cuit: item.organizationCuit,
      organization_legal_name: item.organizationName,
      subscriber_status_id: 1,
      subscriber_max_user_count: maxUsers,
      creation_user: getEmailUserLogged(),
      creation_date: new Date()
    }
    const response = await dispatch(createSuscriberRequest(suscriber, myuuid))
    if (response.subscriber_id) {
      newuser.subscriber_id = response.subscriber_id
    }
    return response
  }

  // return user for create
  const getUser = (idCognito) => {
    return {
      accountExternalRefId: idCognito,
      email: email,
      firstName: businessName,
      modificationUser: getEmailUserLogged(),
      subscriber_max_user_count: 0,
      accountStatusCode: 'ACTIVE'
    }
  }

  // send invite for suscriber process
  const sendInvite = async (newuser, myuuid) => {
    try {
      // create new invite of send
      if (newuser.createStatus) {
        const newInvite = {
          inviteDate: new Date(),
          accountEmail: email,
          userId: newuser.userId,
          firstName: businessName,
          lastName: businessName,
          organizationName: item.organizationName,
          organizationCuit: item.organizationCuit,
          subscriberRefId: number
        }

        // invite user in org request
        const sendCreateInvite = await createSubscriberRegistrationUserInvite(
          newInvite
        )
        logEvent(
          'CGI - createSubscriberRegistrationUserInvite',
          { invite: newInvite, response: sendCreateInvite },
          myuuid
        )
      }
    } catch (error) {
      handleSetError('Ocurrió un error. Intente nuevamente')
      return 'error'
    }
  }

  // assing user suscriber proccess
  const asignUserSuscriber = async (newuser, myuuid) => {
    try {
      const asingSuscriber = {
        user_id: newuser.userId,
        subscriber_id: newuser.subscriber_id,
        creation_user: getEmailUserLogged(),
        creation_date: new Date()
      }

      // assing user in suscriber request
      const assingSuscriberRequest = await assignUserSubscriberCorpEntity(
        asingSuscriber
      )
      logEvent(
        'CGI - assignUserSubscriberCorpEntity',
        {
          body: asingSuscriber,
          response: assingSuscriberRequest
        },
        myuuid
      )
    } catch (error) {
      handleSetError('Ocurrió un error. Intente nuevamente')
      return 'error'
    }
  }

  // verify if user exists in organization selected
  const userExistInOrgReply = (data) => {
    return data.filter((org) => org.organizationId === item.organizationId)
  }

  // assing user in org request
  const assignUserOrganization = async (newuser, myuuid) => {
    // if not exist create User in org and save userId
    try {
      const userOrganization = {
        loginAccountId: newuser.loginAccountId,
        organizationId: item.organizationId,
        organizationUserTypeCode: 'ORG-ADMIN',
        organizationCommercialUserTypeCode: 'SUBSCRIBER',
        userStatusCode: 'ACTIVE'
      }

      // add user in organization request
      const addUserOrganization = await addUserOrganizationCorpEntities(
        userOrganization
      )

      logEvent(
        'CGI - addUserOrganizationCorpEntities',
        {
          userOrganization: userOrganization,
          response: addUserOrganization
        },
        myuuid
      )
      // save userid
      newuser.userId = addUserOrganization.data?.data?.userId
    } catch (err) {
      handleSetError('Ocurrió un error. Intente cargar nuevamente la página')
      return 'error'
    }
  }

  // add user in org process
  const addUserOrganization = async (newuser, myuuid) => {
    try {
      // get info userorganization with loginaccountid request
      const getUserOrganization =
        await getUserOrganizationByLoginAccountCorpEntities(
          newuser.loginAccountId
        )
      // verify is user exists in same org
      const orgWithReplyOrgId = userExistInOrgReply(
        getUserOrganization.data.data
      )
      if (orgWithReplyOrgId.length > 0) {
        // if exist user in same org save userId
        const [org] = orgWithReplyOrgId
        newuser.userId = org.userId
      } else {
        // else not exists, assign user
        const assingUserResponse = await assignUserOrganization(
          newuser,
          myuuid
        )
        if (assingUserResponse === 'error') {
          return 'error'
        }
      }
    } catch (err) {
      handleSetError('Ocurrió un error. Intente cargar nuevamente la página')
      return 'error'
    }
  }

  // create user in cognito process
  const handleCreateUserCognito = async (newuser, myuuid) => {
    try {
      // verify is user exist
      const response = await helpGetUserLoginAccountWithEmail(email)
      // if exist save loginaccountid
      newuser.loginAccountId = response.data?.loginAccount?.loginAccountId
    } catch (err) {
      // else not exist
      const message = err.response?.data?.error?.message
      if (
        message &&
        message.toLowerCase().includes('verify loginaccount email')
      ) {
        let idcognito
        try {
          // create user in cognito request
          const createuserCognitoResponse = await createUserCognito(email)
          // log event
          logEvent(
            'CGI - createUserBaseAccountEAuth',
            { email: email, response: createuserCognitoResponse },
            myuuid
          )
          const { message } = createuserCognitoResponse.data
          // validate error if user exist
          if (message && message.includes('UsernameExistsException')) {
            idcognito = createuserCognitoResponse.data?.cognitoUser?.idCognito
          } else if (
            createuserCognitoResponse.data?.cognitoUser?.User?.Username
          ) {
            idcognito =
              createuserCognitoResponse.data?.cognitoUser?.User?.Username
          }

          // get new user of create login account
          const user = getUser(idcognito)
          // create usuario loggin account request
          const createUserAccount = await createUser(user)

          logEvent(
            'CGI - loginAccountCreate',
            { user: user, response: createUserAccount },
            myuuid
          )
          // save login accoutn id and set true createStatus for invite process
          newuser.loginAccountId = createUserAccount.data?.data?.loginAccountId
          newuser.createStatus = true
        } catch (err) {
          handleSetError(
            'Ocurrió un error. Intente cargar nuevamente la página'
          )
          return 'error'
        }
      } else {
        handleSetError('Ocurrió un error. Intente cargar nuevamente la página')
        return 'error'
      }
    }
  }

  // Create Suscriber Submit
  const handleCreateSuscriber = async () => {
    if (isAttributesCompleted()) {
      if (!item.organizationId) {
        handleSetError('Ocurrió un error. Intente cargar nuevamente la página')
        return
      }
      // new uuid for log event
      const myuuid = uuidv4()

      // verify is user exist
      const existsSuscriber = await isExistSuscriber(number)
      if (existsSuscriber === ' error') {
        // error
        return
      }

      // user suscriber for other actions
      const newuser = {
        loginAccountId: '',
        userId: '',
        idCognito: '',
        loginAccountState: '',
        userOrganizationState: '',
        subscriber_id: '',
        createStatus: false
      }

      // create suscriber
      const createSuscriberResponse = await createSuscriberProcess(
        newuser,
        myuuid
      )
      if (createSuscriberResponse === 'error') {
        // error
        return
      }
      //*
      // create user in cognito
      const createUserResponse = await handleCreateUserCognito(newuser, myuuid)
      if (createUserResponse === 'error') {
        // error
        return
      }
      // assign user in organization
      const assignUserOrganizationResponse = await addUserOrganization(
        newuser,
        myuuid
      )
      if (assignUserOrganizationResponse === 'error') {
        // error
        return
      }
      // assign user in suscriber
      const asssigsuscriber = await asignUserSuscriber(newuser, myuuid)
      if (asssigsuscriber === 'error') {
        return
      }
      // send invite
      const inviteResponse = await sendInvite(newuser, myuuid)
      if (inviteResponse === 'error') {
        return
      }
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar('Suscriptor agregado con éxito.'))

      setstateAddSuscriber(false)
    }
  }
  return (
    <Box sx={{ width: '100%' }}>
      <Box>
        <Box
          sx={{
            marginLeft: '5%',
            width: '90%',
            marginTop: '2%'
          }}
        >
          <Typography
            sx={{
              mt: 2,
              mb: 1,
              fontWeight: 'bold',
              color: '#32332E',
              fontSize: 18
            }}
          >
            Añadir un suscriptor a la organización
          </Typography>
          <Typography sx={{ mt: 2, mb: 1, fontSize: 15 }}>
            Complete los siguientes datos del nuevo suscriptor que desea
            agregar:
          </Typography>

          <Typography sx={{ mt: 2, mb: 1, fontSize: 14 }}>
            Correo electrónico:
          </Typography>
          <TextField
            id="standard-size-small"
            size="small"
            variant="standard"
            required
            value={email}
            onChange={handleChangeEmail}
            error={errorEmail}
            helperText={errorEmail ? errorText : null}
            style={{ width: '70%' }}
          />
          <Typography sx={{ mt: 2, mb: 1, fontSize: 14 }}>
            Número de suscriptor:
          </Typography>
          <TextField
            id="standard-size-small"
            size="small"
            variant="standard"
            required
            value={number}
            onChange={handleChangeNumber}
            error={errorNumber}
            helperText={errorNumber ? errorText : null}
            style={{ width: '70%' }}
          />
          <Typography sx={{ mt: 2, mb: 1, fontSize: 14 }}>
            Razón social:
          </Typography>
          <TextField
            id="standard-size-small"
            size="small"
            variant="standard"
            required
            value={businessName}
            onChange={handleChangebusinessName}
            error={errorbusinessName}
            helperText={errorbusinessName ? errorText : null}
            style={{ width: '70%' }}
          />
          <Typography sx={{ mt: 2, mb: 1, fontSize: 14 }}>
            Máximo de usuarios:
          </Typography>
          <TextField
            id="standard-number"
            type="number"
            style={{ width: '70%' }}
            InputLabelProps={{
              shrink: true
            }}
            variant="standard"
            value={maxUsers}
            onChange={handleChangeMaxUsers}
            error={errorMaxUsers}
            helperText={errorMaxUsers ? errorText : null}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          pt: 2,
          marginLeft: '5%',
          width: '90%',
          position: 'absolute',
          bottom: 20
        }}
      >
        <Box
          sx={{
            width: 90,
            height: 35,

            backgroundColor: '#1C846F',
            boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
            WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
            MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
            borderRadius: 1,
            display: 'flex',
            '&:hover': {
              bgcolor: '#1BF57F'
            },
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Typography
            sx={{
              color: '#FFFFFF',
              cursor: 'pointer',
              fontSize: 16
            }}
            onClick={handleCreateSuscriber}
          >
            Crear
          </Typography>
        </Box>
        <ButtonCancel setstateAddSuscriber={setstateAddSuscriber} />
      </Box>
    </Box>
  )
}

function ButtonCancel ({ setstateAddSuscriber }) {
  return (
    <Box
      sx={{
        width: 90,
        height: 35,
        marginLeft: 2,
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
        WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
        MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
        borderRadius: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Typography
        onClick={() => {
          setstateAddSuscriber(false)
        }}
        sx={{
          color: '#262626',
          cursor: 'pointer',
          fontSize: 16,
          '&:hover': {
            color: '#1BF57F'
          }
        }}
      >
        Cancelar
      </Typography>
    </Box>
  )
}
